import _defineProperty from '@babel/runtime/helpers/defineProperty';
import styled, { css } from 'styled-components';
import { siteThemes, theme } from '../../utils/theming.js';

var DEFAULT = siteThemes.DEFAULT,
  GLOBETROTTER = siteThemes.GLOBETROTTER;
var backgroundColor = theme('site', _defineProperty(_defineProperty({}, DEFAULT, css(["var(--color-teal-800)"])), GLOBETROTTER, css(["var(--color-background-surface-secondary)"])));
var checkedIconStrokeColor = theme('site', _defineProperty(_defineProperty({}, DEFAULT, css(["var(--color-teal-800)"])), GLOBETROTTER, css(["var(--color-background-surface-tertiary)"])));
var uncheckedIconStrokeColor = theme('site', _defineProperty(_defineProperty({}, DEFAULT, css(["var(--color-white)"])), GLOBETROTTER, css(["var(--color-background-surface-primary)"])));
var checkedIconFillColor = theme('site', _defineProperty(_defineProperty({}, DEFAULT, css(["var(--color-white)"])), GLOBETROTTER, css(["none"])));
var uncheckedIconFillColor = theme('site', _defineProperty(_defineProperty({}, DEFAULT, css(["var(--color-teal-800)"])), GLOBETROTTER, css(["none"])));
var checkedTextColor = theme('site', _defineProperty(_defineProperty({}, DEFAULT, css(["var(--color-teal-800)"])), GLOBETROTTER, css(["var(--color-background-surface-tertiary)"])));
var uncheckedTextColor = theme('site', _defineProperty(_defineProperty({}, DEFAULT, css(["var(--color-white)"])), GLOBETROTTER, css(["var(--color-background-surface-primary)"])));
var Container = styled.div.withConfig({
  displayName: "style__Container",
  componentId: "sc-1fbw2i4-0"
})(["position:relative;display:inline-flex;background-color:", ";"], backgroundColor);
var Label = styled.label.withConfig({
  displayName: "style__Label",
  componentId: "sc-1fbw2i4-1"
})(["position:absolute;visibility:hidden;z-index:-1;"]);
var Input = styled.input.withConfig({
  displayName: "style__Input",
  componentId: "sc-1fbw2i4-2"
})(["position:absolute;z-index:2;width:100%;height:100%;cursor:pointer;"]);
var ValueContainer = styled.div.withConfig({
  displayName: "style__ValueContainer",
  componentId: "sc-1fbw2i4-3"
})(["position:relative;z-index:1;display:flex;padding:var(--space-200) var(--space-300);& > svg{", "}& > p,& > span{", "}"], function (_ref) {
  var $checked = _ref.$checked;
  return $checked ? css(["stroke:", ";fill:", ";"], checkedIconStrokeColor, checkedIconFillColor) : css(["stroke:", ";fill:", ";"], uncheckedIconStrokeColor, uncheckedIconFillColor);
}, function (_ref2) {
  var $checked = _ref2.$checked;
  return $checked ? css(["color:", ";"], checkedTextColor) : css(["color:", ";"], uncheckedTextColor);
});
var SelectIndicator = styled.span.withConfig({
  displayName: "style__SelectIndicator",
  componentId: "sc-1fbw2i4-4"
})(["position:absolute;width:calc((100% / 2) - 2px);height:calc(100% - 2px);margin:1px;border:1px solid var(--color-background-surface-primary);border-radius:1px;background-color:var(--color-background-surface-primary);transition:transform 0.2s ease-in-out;", ""], function (_ref3) {
  var $checked = _ref3.$checked;
  return $checked ? css(["transform:translateX(calc(100% + 2px));"]) : css(["transform:translateX(0);"]);
});

export { Container, Input, Label, SelectIndicator, ValueContainer };
//# sourceMappingURL=style.js.map
